export function Testimonials() {
  const testimonials = [
    {
      name: 'Marcus Chen',
      role: 'Growth Hacker',
      company: 'TechStartups.io',
      initials: 'MC',
      avatarBg: 'linear-gradient(135deg, #3B82F6, #6366F1)',
      rating: 5,
      text: 'GetCode saved me hours every week. I manage 40+ accounts across platforms and the instant OTP delivery is a genuine game-changer. Never missed a code.',
    },
    {
      name: 'Sarah Kowalski',
      role: 'Digital Marketer',
      company: 'BrandLabs Agency',
      initials: 'SK',
      avatarBg: 'linear-gradient(135deg, #8B5CF6, #EC4899)',
      rating: 5,
      text: "The privacy angle is what sold me. I don't give my real number to sketchy services anymore. GetCode is a permanent fixture in my workflow now.",
    },
    {
      name: 'Daniel Osei',
      role: 'Software Developer',
      company: 'Freelance',
      initials: 'DO',
      avatarBg: 'linear-gradient(135deg, #10B981, #3B82F6)',
      rating: 5,
      text: "I've tested every SMS verification service out there. GetCode wins on reliability, speed, and pricing. The 99.8% success rate is real — I've tracked it.",
    },
  ]

  return (
    <section
      style={{
        padding: '80px 0 120px',
        background: 'white',
        borderTop: '1px solid #F1F5F9',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: '#FFFBEB',
              border: '1px solid #FDE68A',
              borderRadius: '100px',
              padding: '6px 16px',
              marginBottom: '20px',
            }}
          >
            <span style={{ color: '#F59E0B', fontSize: '13px' }}>★★★★★</span>
            <span
              style={{
                fontSize: '12px',
                letterSpacing: '0.5px',
                color: '#D97706',
                fontWeight: '600',
              }}
            >
              Trusted by thousands
            </span>
          </div>
          <h2
            style={{
              fontSize: 'clamp(28px, 3.5vw, 46px)',
              fontWeight: '800',
              letterSpacing: '-1px',
              color: '#0F172A',
              margin: 0,
            }}
          >
            What our users say
          </h2>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '20px',
          }}
        >
          {testimonials.map((t, i) => (
            <div
              key={i}
              style={{
                background: '#FAFAFA',
                border: '1.5px solid #F1F5F9',
                borderRadius: '20px',
                padding: '32px',
                transition: 'all 0.3s ease',
                position: 'relative',
                overflow: 'hidden',
                boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)'
                e.currentTarget.style.borderColor = '#FDE68A'
                e.currentTarget.style.boxShadow =
                  '0 16px 48px rgba(245,158,11,0.1)'
                e.currentTarget.style.background = 'white'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.borderColor = '#F1F5F9'
                e.currentTarget.style.boxShadow = '0 1px 6px rgba(0,0,0,0.04)'
                e.currentTarget.style.background = '#FAFAFA'
              }}
            >
              {/* Big quote */}
              <div
                style={{
                  position: 'absolute',
                  top: '16px',
                  right: '20px',
                  fontSize: '72px',
                  color: 'rgba(245,158,11,0.1)',
                  fontFamily: 'Georgia, serif',
                  lineHeight: 1,
                  userSelect: 'none',
                }}
              >
                {'"'}
              </div>

              <div
                style={{ display: 'flex', gap: '3px', marginBottom: '16px' }}
              >
                {Array.from({ length: t.rating }).map((_, j) => (
                  <span key={j} style={{ color: '#F59E0B', fontSize: '14px' }}>
                    ★
                  </span>
                ))}
              </div>

              <p
                style={{
                  fontSize: '15px',
                  color: '#374151',
                  lineHeight: '1.75',
                  margin: '0 0 24px',
                }}
              >
                {'"'}
                {t.text}
                {'"'}
              </p>

              <div
                style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
              >
                <div
                  style={{
                    width: '44px',
                    height: '44px',
                    borderRadius: '12px',
                    background: t.avatarBg,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '14px',
                    fontWeight: '700',
                    color: 'white',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                  }}
                >
                  {t.initials}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: '14px',
                      fontWeight: '700',
                      color: '#0F172A',
                    }}
                  >
                    {t.name}
                  </div>
                  <div
                    style={{
                      fontSize: '12px',
                      color: '#9CA3AF',
                      marginTop: '2px',
                    }}
                  >
                    {t.role} · {t.company}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
